var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"cookies-modal"},[_c('h4',[_vm._v("Cookies")]),_c('p',[_vm._v(" Этот сайт использует cookies для хранения данных. Продолжая использовать сайт, вы даете согласие на работу с этими файлами. ")]),_c('vr-button',{attrs:{"size":"small","outlined":""},on:{"click":_vm.accept}},[_vm._v("Принять")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }